import { render } from "./LdvConfigOptionsTable.vue?vue&type=template&id=15656aee"
import script from "./LdvConfigOptionsTable.vue?vue&type=script&lang=js"
export * from "./LdvConfigOptionsTable.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./LdvConfigOptionsTable.vue?vue&type=style&index=0&id=15656aee&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script